import script from "./BulkEditNoteForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkEditNoteForm.vue?vue&type=script&setup=true&lang=js"

import "./BulkEditNoteForm.vue?vue&type=style&index=0&id=2130f7ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2130f7ce"]])

export default __exports__